import correctAudio from './assets/mini-task-correct.wav';
import retryAudio from './assets/mini-task-retry.mp3';
import practiceEndAudio from './assets/mini-task-practice-end.mp3';

export const CORRECT_FEEDBACK_AUDIO = correctAudio;
// Exact approved Tomris tr_l4_wrong bytes, reused for generic encouragement.
// Provenance: docs/visual-qa/G12_SHARED_RETRY_AUDIO_20261101.md.
export const RETRY_FEEDBACK_AUDIO = retryAudio;
export const RETRY_FEEDBACK_TEXT = 'Bir daha deneyelim.';
// User-approved Backend #587 MP3, exact SHA recorded in the companion QA doc.
export const PRACTICE_END_FEEDBACK_AUDIO = practiceEndAudio;
export const isCorrectFeedback = (id) => id === 's_l1_g2_pop';

// Keep frozen content IDs intact; both players use correctSoundSequence.json.
export const feedbackAudioUrl = (id, url) => isCorrectFeedback(id) ? CORRECT_FEEDBACK_AUDIO : url;
